import { ReactNode } from 'react';
import classNames from 'classnames';
import Header from 'components/organisms/NavController/Header';

function NavController({ children }: { children: ReactNode }) {
  return (
    <div className="flex-col w-full flex md:flex-row md:min-h-screen font-sans bg-white">
      <Header />
      <div className={classNames('flex-col w-full md:flex md:flex-row pt-16 md:pt-20 mb-[4rem] md:mb-0')}>
        <div className={classNames('flex flex-col w-full min-h-[calc(100vh_-_8.5rem)] bg-white p-6')}>
          <div className="flex-1 h-full">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default NavController;
